import { type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, IconButton, Stack } from '@dhl-ui/components'

import { LanguageSelect } from '@dhl/receiver-design'
import { HeaderItem } from '@dhl-ui/page'
import { FlagIcon, LockOpenIcon } from '@dhl-ui/icons'
import { links } from '~/appLinks'
import { isFeatureEnabled } from '~/config'
import { locales, useLocalStorageForLocale } from '~/i18n'

export const HeaderContent: FC = () => {
  const { t } = useTranslation()
  const [, storeLocale] = useLocalStorageForLocale()

  const handleSignInClick = () => {
    window.location.href = links.signInLink()
  }

  return (
    <Stack direction="row" spacing={1} sx={{ gap: { xs: 1, md: 2 }, alignItems: 'center' }}>
      <HeaderItem
        id="language"
        priority={2}
        compactChildren={
          <IconButton aria-label="flag" size="small" color="inherit">
            <FlagIcon />
          </IconButton>
        }
      >
        <LanguageSelect format="short" locales={locales()} sx={{ minWidth: 74 }} onChange={storeLocale} />
      </HeaderItem>

      {isFeatureEnabled('profile') && (
        <HeaderItem
          id="login"
          priority={1}
          compactChildren={
            <IconButton aria-label="unlock" size="small" color="inherit">
              <LockOpenIcon />
            </IconButton>
          }
        >
          <Button data-test="btn-goto-login" onClick={handleSignInClick} size="small" variant="contained">
            {t('onboarding.loginButton')}
          </Button>
        </HeaderItem>
      )}
    </Stack>
  )
}
